import React, { useEffect, useState } from 'react';
import { InputGroup, InputGroupAddon, Input } from 'reactstrap';
import { FaSearch, FaTimes } from 'react-icons/fa';

function SearchBar({
    searchPlaceholder = 'Search Rx #',
    onSearch,
    onValueChange,
    clearTrigger,
    value,
}) {
    const [searchValue, setSearchValue] = useState(value ?? '');

    useEffect(() => {
        setSearchValue('');
    }, [clearTrigger]);

    useEffect(() => {
        if (value !== undefined) {
            setSearchValue(value);
        }
    }, [value]);

    const handleSearch = () => {
        if (onSearch) {
            onSearch(searchValue);
        }
    };

    const handleClear = () => {
        setSearchValue('');
        if (onValueChange) {
            onValueChange('');
        }
        if (onSearch) {
            onSearch('');
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <div className=" d-flex align-items-center ">
            <label
                className="mb-0 font-weight-bold text-dark "
                style={{ minWidth: '100px', fontSize: '18px', marginRight: '4px' }}>
                {searchPlaceholder}
            </label>
            <InputGroup style={{ flex: 1 }}>
                <Input
                    type="text"
                    value={searchValue}
                    onChange={(e) => {
                        const nextValue = e.target.value;
                        setSearchValue(nextValue);
                        if (onValueChange) {
                            onValueChange(nextValue);
                        }
                    }}
                    onKeyPress={handleKeyPress}
                    placeholder={searchPlaceholder}
                />
                {searchValue && (
                    <InputGroupAddon addonType="append">
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={handleClear}
                            style={{ cursor: 'pointer', border: '1px solid #b1b1b1' }}>
                            <FaTimes />
                        </button>
                    </InputGroupAddon>
                )}
                {/* <InputGroupAddon addonType="append">
                    <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={handleSearch}
                        style={{ cursor: 'pointer' }}>
                        <FaSearch />
                    </button>
                </InputGroupAddon> */}
            </InputGroup>
        </div>
    );
}

export default SearchBar;
